// SearchProvider.js
class SearchProvider {
  loadScript(src, integrity, crossorigin) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      if (integrity) script.integrity = integrity;
      if (crossorigin) script.crossOrigin = crossorigin;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;

      document.head.appendChild(script);
    });
  }
  async fetchResults(query) {
    throw new Error("Method 'search' must be implemented.");
  }
  async search(query, hitsPerPage = 12, page = 1) {
    const results = await this.fetchResults(query, hitsPerPage, page);
    return results;
  }
}
class AlgoliaProvider extends SearchProvider {
  constructor() {
    super();
    this.client = null;
    this.index = null;
    this.suggestions_index = null;
    this.collections_index = null;
    this.pages_index = null;
    this.scriptLoaded = this.init();
  }
  async init() {
    // Load the Algolia script dynamically
    await this.loadScript(
      "https://cdn.jsdelivr.net/npm/algoliasearch@4.24.0/dist/algoliasearch-lite.umd.js",
      "sha256-b2n6oSgG4C1stMT/yc/ChGszs9EY/Mhs6oltEjQbFCQ=",
      "anonymous"
    );

    // Initialize Algolia client after the script is loaded
    const algoliasearch = window.algoliasearch;
    this.client = algoliasearch(
      "MQ8QXOO1WP",
      "91d6c4433d7d085487beaa7ff19387a2"
    );
    this.index = this.client.initIndex("shopify_products");
    this.suggestions_index = this.client.initIndex(
      "shopify_products_query_suggestions"
    );
    this.collections_index = this.client.initIndex("shopify_collections");
    // this.pages_index = this.client.initIndex("shopify_articles");
  }

  async fetchResults(query, hitsPerPage = 12, page = 1) {
    await this.scriptLoaded; // Ensure script is loaded and Algolia is initialized

    const [
      searchProductsResponse,
      searchCollectionsResponse,
      searchSuggestionsResponse,
      searchPagesResponse,
    ] = await Promise.all([
      this.index.search(query, { hitsPerPage, page }),
      this.collections_index.search(query, { hitsPerPage, page }),
      this.suggestions_index.search(query, { hitsPerPage, page }),
      // this.pages_index.search(query, { hitsPerPage, page }),
    ]);
    const hits = searchProductsResponse.hits || [];
    const suggestions = searchSuggestionsResponse?.hits || [];
    const pages = searchPagesResponse?.hits || [];
    const collections = searchCollectionsResponse?.hits || [];
    // Standardizing the response

    return {
      collections: collections.map((collection) => {
        return collection;
      }),
      suggestions: suggestions.map((suggestion) => {
        return suggestion.query;
      }),
      pages: pages.map((page) => {
        return {
          title: page.title,
          url: `/blogs/simple-blog/${page.handle}`,
          image: page.image,
        };
      }),
      items: hits.map((hit) => {
        hit.meta.custom_fields = hit.meta.custom_fields || {};
        return {
          title: hit.title,
          compare_at_price: hit.compare_at_price,
          price: hit.price,
          quantity: hit.inventory_quantity,
          url: `/products/${hit.handle}`,
          image: hit.image,
          tagline: hit.meta.custom_fields.tagline || "",
          variant_id: hit.objectID,
          sort_index: 0, //hit.recently_ordered_count
        };
      }),
    };
  }
}

class SearchProviderFactory {
  static createProvider(providerType) {
    switch (providerType) {
      case "searchanise":
        return new SearchaniseProvider();
        break;
      case "algolia":
        return new AlgoliaProvider();
        break;
      default:
        throw new Error("Invalid provider type");
    }
  }
}
// window.SimpleCore._helpers.triggerEvent("search-engine:loaded");
